import React, {useEffect, useState} from 'react';
import youtube from '../api/youtube';

import YTVideoList from '../YTVideoList/YTVideoList';

const YTVideo = ({playlistId, title, selected, setSelected}) =>{
	const [videos, setVideos] = useState([]);
	const [selectedVideo, setSelectedVideo] = useState(null);

	useEffect(()=> {
		async function fetchYoutubeAPI() {
			const videoRes = await youtube.get('/playlistItems', {
				params:{
					playlistId:playlistId
				}
			});
			setVideos(videoRes.data.items);
		}
		fetchYoutubeAPI();
	},[playlistId]);

	return (
		<>
			{ videos && 
				<div className="yt-list-container"> 
					<YTVideoList selected={ selected } playlistId={ playlistId } onVideoSelect={(video)=>{setSelectedVideo(video);setSelected(playlistId);}} videos={videos} selectedVideo={selectedVideo} title={title}/>
				</div> 
			}
		</>
	)
}

export default YTVideo;